<button
    class="card flex justify-center items-center rounded-[10px] border-2 text-center h-full min-h-[30px] w-full max-w-screen-sm transition duration-300 ease-in-out focus:ring-2 focus:ring-black"
    [ngClass]="[isDisabled ? disabledBackgroundColor : backgroundColor, isDisabled ? disabledTextColor : textColor,
    isDisabled ? 'cursor-not-allowed' : '', isDisabled ? disabledBorderColor : borderColor, !isDisabled ? hoverBackgroundColor : '', !isDisabled ? hoverTextColor : '',
    !isDisabled ? hoverBorderColor : '', fontWeight 
    ]" [disabled]="isDisabled" (click)="onClick()">
    {{ buttonText }}
</button>